import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Divider,
  Typography,
  Button,
  Grid,
  Stack,
  Box,
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

import _ from 'lodash';
import * as chanceApi from '../../../lib/api/chance';
import CommentForm from './CommentForm';
import ReplyComment from './ReplyComment';
import EditorComponent from '../editor/EditorComponent';
import EditorViewComponent from '../editor/EditorViewComponent';
import { listComments } from '../../../modules/techModule/projectComments';

const SingleComment = ({ commentList, project, comment }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }));

  const [replyComments, setReplyComments] = useState([]);

  useEffect(() => {
    if (commentList) {
      setReplyComments(
        _.filter(commentList, (com) => com.parentBrdUuid === comment.brdUuid),
      );

      // console.log(replyComments, 'replyComments');
    }
  }, [commentList]);

  const [edit, setEdit] = useState(false);
  const handleEdit = () => {
    setEdit(true);
    setCommentValue(comment.brdTxt);
  };

  //댓글 클릭시
  const [openReply, setOpenReply] = useState(false);
  const onClickReplyOpen = () => {
    //toggle
    setOpenReply(!openReply);
  };

  const [commentValue, setCommentValue] = useState('');
  const handleEditorChange = (data) => {
    setCommentValue(data);
  };

  //댓글 달기
  const onReplySubmit = async (event) => {
    event.preventDefault(); //refresh 막음
    const variables = {
      brdTxt: commentValue,
      prjUuid: project.prjUuid,
      parentBrdUuid: comment.brdUuid,
    };

    try {
      const res = await chanceApi.addComment(variables);

      if (res.data) {
        setCommentValue('');
        dispatch(listComments(project.prjUuid));

        //setOpenReply(false);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onEdit = async () => {
    //수정
    try {
      comment.brdTxt = commentValue;
      const res = await chanceApi.editComment(comment);

      if (res.data) {
        setCommentValue('');
        dispatch(listComments(project.prjUuid));
        setEdit(false);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onRemove = async () => {
    try {
      const res = await chanceApi.removeComment(comment.brdUuid);

      if (res.data) {
        dispatch(listComments(project.prjUuid));
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Divider variant="middle" sx={{ my: 2 }} />
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid
          item
          xs={2}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            {comment.profileImg ? (
              <Avatar alt={comment.crtNm} src={comment.profileImg} />
            ) : (
              <Avatar>{comment.crtNm.substring(0, 1)}</Avatar>
            )}
          </Grid>
          <Grid item>
            <Typography variant="body2">{comment.crtNm}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2">{comment.crtDt}</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={10}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            item
            sx={{ width: '100%', minHeight: '50px', whiteSpace: 'pre-line' }}
          >
            {edit ? (
              <EditorComponent
                value={commentValue}
                onChange={handleEditorChange}
              />
            ) : (
              //<div dangerouslySetInnerHTML={{ __html: comment.brdTxt }}></div>
              <EditorViewComponent content={comment.brdTxt} />
            )}
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              px: 1,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={onClickReplyOpen}
              >
                댓글{' '}
                {replyComments.length > 0 ? `(${replyComments.length})` : ''}
              </Button>
              {user.usrUuid === comment.crtUsr && (
                <>
                  {!edit ? (
                    <>
                      <Button
                        size="small"
                        color="info"
                        variant="outlined"
                        onClick={handleEdit}
                      >
                        수정
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        onClick={onEdit}
                      >
                        저장
                      </Button>
                      <Button
                        size="small"
                        color="info"
                        variant="contained"
                        onClick={() => setEdit(false)}
                      >
                        취소
                      </Button>
                    </>
                  )}
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={onRemove}
                  >
                    삭제
                  </Button>
                </>
              )}
            </Stack>
          </Grid>

          {openReply && (
            <Grid
              item
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              sx={{
                px: 1,
                borderTop: 1,
              }}
            >
              <Grid
                item
                sx={{
                  width: '100%',
                  minHeight: '80px',
                  whiteSpace: 'pre-line',
                }}
              >
                {/* <CommentForm
                  commentValue={commentValue}
                  onSubmit={onReplySubmit}
                  handleChange={handleChange}
                /> */}
                <CommentForm
                  commentValue={commentValue}
                  onSubmit={onReplySubmit}
                  handleChange={handleEditorChange}
                />
              </Grid>

              {replyComments.length > 0 &&
                replyComments.map((reply, index) => (
                  <>
                    <Box sx={{ width: '100%' }} key={index}>
                      <ReplyComment comment={reply} project={project} />
                    </Box>
                  </>
                ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SingleComment;
